import React, { useEffect, useState } from "react";
import { Loader, Header, Icon } from "semantic-ui-react";
import { size, map } from "lodash";
import { Competence } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CompetenceItem } from "../CompetenceItem";
import "./ListCompetence.scss";

const competenceController = new Competence();

export function ListCompetence(props) {
  const { subjectId, gradeId, reload, onReload } = props;
  const [competences, setCompetences] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    if (!subjectId || !gradeId) {
      setCompetences([]);
      return;
    }

    (async () => {
      try {
        setCompetences(null);
        const response =
          await competenceController.getCompetencesBySubjectAndGrade(
            accessToken,
            subjectId,
            gradeId,
          );
        setCompetences(response);
      } catch (error) {
        console.error(error);
        setCompetences([]);
      }
    })();
  }, [subjectId, gradeId, reload, accessToken]);

  if (!subjectId || !gradeId) {
    return (
      <div className="admin-competence-list__empty">
        <Icon name="clipboard list" size="huge" />
        <p>Selecciona una asignatura y un grado para ver las competencias.</p>
      </div>
    );
  }

  if (competences === null)
    return <Loader active inline="centered" content="Cargando..." />;

  if (size(competences) === 0) {
    return (
      <>
        <Header as="h4">No hay competencias registradas</Header>
        <p>
          No existen competencias para esta asignatura y grado. Puedes crear una
          nueva.
        </p>
      </>
    );
  }

  return map(competences, (competence) => (
    <CompetenceItem
      key={competence.id}
      competence={competence}
      onReload={onReload}
    />
  ));
}
